module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('steps', {
    attrs: {
      "currentStep": _vm.currentStep
    },
    on: {
      "switchStep": _vm.switchStep
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "new-product"
  }, [_c('div', {
    staticClass: "my-4"
  }, [(_vm.step === _vm.currentStep) ? _c('div', [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.switchStep($event)
      },
      "input": function($event) {
        return _vm.productAcivateUpdateFlag('salesChannels')
      }
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-end align-items-center border-bottom-light my-4 p-4"
  }, [_c('button', {
    staticClass: "btn blue wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.prevStep
    }
  }, [_c('i', {
    staticClass: "ico-arrow-left fs-normal ml-2"
  }), _vm._v(" Back")]), _vm._v(" "), _c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.getSelectedItem !== null) ? _c('button', {
    staticClass: "btn green wider mr-3",
    attrs: {
      "type": "button",
      "disabled": _vm.$v.$invalid
    },
    on: {
      "click": _vm.readyToSave
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn blue wider",
    attrs: {
      "type": "button",
      "disabled": _vm.$v.$invalid
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Next "), _c('i', {
    staticClass: "ico-arrow-right fs-normal ml-2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "px-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "panel shaded"
  }, [_c('h5', [_vm._v("Sales channel permissions")]), _vm._v(" "), _c('div', {
    staticClass: "fs-small dark mt-2 mb-3"
  }, [_vm._v("\n                                        Select the sales channel were this product will be available for sale\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group pt-4 channelOptions"
  }, _vm._l((_vm.form.channelCommissions), function(salesChannel, index) {
    return _c('div', {
      staticClass: "full mb-3 pRelative mb-3"
    }, [_c('div', {
      staticClass: "d-flex align-items-center justify-content-between"
    }, [_c('div', {}, [_c('div', {
      staticClass: "d-flex align-items-center mt-3"
    }, [_c('checkbox', {
      staticClass: "mt-1",
      on: {
        "input": function($event) {
          return _vm.salesChannelStateChanged(salesChannel)
        }
      },
      model: {
        value: (salesChannel.isActive),
        callback: function($$v) {
          _vm.$set(salesChannel, "isActive", $$v)
        },
        expression: "salesChannel.isActive"
      }
    }, [_vm._v("\n                                                            " + _vm._s(salesChannel.channelName) + "\n                                                        ")]), _vm._v(" "), (salesChannel.channelType == 50) ? _c('div', {
      staticClass: "ml-2"
    }, [_c('v-select', {
      attrs: {
        "options": _vm.agentsChannelOptions,
        "disabled": !salesChannel.isActive
      },
      on: {
        "input": function($event) {
          return _vm.agentsChannelOptionsChanged($event, salesChannel)
        }
      },
      model: {
        value: (_vm.selectedAgentsChannelOptions),
        callback: function($$v) {
          _vm.selectedAgentsChannelOptions = $$v
        },
        expression: "selectedAgentsChannelOptions"
      }
    })], 1) : _vm._e()], 1), _vm._v(" "), (salesChannel.channelType == 50) ? _c('div', [(_vm.form.salesPermissionsAgentsCustom) ? _c('div', {
      staticClass: "d-flex flex-column pRelative ml-4"
    }, [_c('agent-white-list', {
      staticClass: "mt-2",
      attrs: {
        "allowedList": _vm.form.salesPermissionsAgentsList,
        "blockedList": _vm.form.salesBlockedAgentList,
        "startAllSelected": _vm.customAgentListSelectAll
      },
      on: {
        "input": _vm.agentListChanged
      }
    })], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "align-self-start"
    }, [_c('div', {
      staticClass: "d-flex "
    }, [_c('div', {
      staticClass: "mr-4"
    }, [_c('span', {
      staticClass: "dark fs-small bold"
    }, [_vm._v("Product Ticket")]), _vm._v(" "), _c('div', {
      staticClass: "d-flex"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (salesChannel.productAmountValue),
        expression: "salesChannel.productAmountValue"
      }],
      staticClass: "glued-right",
      staticStyle: {
        "width": "80px"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (salesChannel.productAmountValue)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(salesChannel, "productAmountValue", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('v-select', {
      staticClass: "glued-left",
      staticStyle: {
        "width": "50px"
      },
      attrs: {
        "options": _vm.getPercentageOrCurrency
      },
      on: {
        "input": function($event) {
          return _vm.commissionTypeChanged(salesChannel, index, 'productAmountType')
        }
      },
      model: {
        value: (salesChannel.productAmountType_helper_selected),
        callback: function($$v) {
          _vm.$set(salesChannel, "productAmountType_helper_selected", $$v)
        },
        expression: "salesChannel.productAmountType_helper_selected"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "dark fs-small bold"
    }, [_vm._v("Extras")]), _vm._v(" "), _c('div', {
      staticClass: "d-flex"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (salesChannel.componentAmountValue),
        expression: "salesChannel.componentAmountValue"
      }],
      staticClass: "glued-right",
      staticStyle: {
        "width": "80px"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (salesChannel.componentAmountValue)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(salesChannel, "componentAmountValue", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('v-select', {
      staticClass: "glued-left",
      staticStyle: {
        "width": "50px"
      },
      attrs: {
        "options": _vm.getPercentageOrCurrency
      },
      on: {
        "input": function($event) {
          return _vm.commissionTypeChanged(salesChannel, index, 'componentAmountType')
        }
      },
      model: {
        value: (salesChannel.componentAmountType_helper_selected),
        callback: function($$v) {
          _vm.$set(salesChannel, "componentAmountType_helper_selected", $$v)
        },
        expression: "salesChannel.componentAmountType_helper_selected"
      }
    })], 1)])])])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "panel shaded"
  }, [_c('h5', [_vm._v("Booking confirmation")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "full"
  }, [_c('span', {
    staticClass: "d-flex"
  }, [_vm._v("\n                                                    Manual confirmation\n                                                "), _c('toggle-button', {
    staticClass: "ml-auto",
    attrs: {
      "labels": {
        checked: 'YES',
        unchecked: 'NO'
      }
    },
    model: {
      value: (_vm.form.hasManualConfirmation),
      callback: function($$v) {
        _vm.$set(_vm.form, "hasManualConfirmation", $$v)
      },
      expression: "form.hasManualConfirmation"
    }
  })], 1), _vm._v(" "), _vm._m(0)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end align-items-center border-bottom-light my-4 p-4"
  }, [_c('button', {
    staticClass: "btn blue wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.prevStep
    }
  }, [_c('i', {
    staticClass: "ico-arrow-left fs-normal ml-2"
  }), _vm._v(" Back")]), _vm._v(" "), _c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.getSelectedItem !== null) ? _c('button', {
    staticClass: "btn green wider mr-3",
    attrs: {
      "type": "button",
      "disabled": _vm.$v.$invalid
    },
    on: {
      "click": _vm.readyToSave
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn blue wider",
    attrs: {
      "type": "button",
      "disabled": _vm.$v.$invalid
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Next "), _c('i', {
    staticClass: "ico-arrow-right fs-normal ml-2"
  })])])])]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fs-smaller mt-2 normal"
  }, [_vm._v("\n                                                    If this option is\n                                                    "), _c('span', {
    staticClass: "underlined"
  }, [_vm._v("enabled")]), _vm._v("\n                                                    , every booking coming from customers and\n                                                    agents is not confirmed until you manually accept it.\n                                                ")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-5b77aac0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b77aac0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/ProductChannels.vue
// module id = 1931
// module chunks = 0